import React, { useState } from "react";
import axios from "axios";
import { message, Alert, Spin } from "antd";
import APIURL from "../api/apiClient";

const ExcelImport = () => {
  const [selectFile, setSelectFile] = useState(null);
  const [showMessage, setShowMessage] = useState("");
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [importStats, setImportStats] = useState({ imported: 0, skipped: 0 });

  const handleChange = (e) => {
    const file = e.target.files[0];
    setSelectFile(file);
    setShowMessage("");
    setErrors([]);
    setImportStats({ imported: 0, skipped: 0 });
  };


  const handleSubmit = async (e) => {
  e.preventDefault();
  setErrors([]);
  setShowMessage("");
  setImportStats({ imported: 0, skipped: 0 });

  if (!selectFile) {
    const msg = "No file selected";
    setShowMessage(msg);
    message.error(msg);
    return;
  }

  const validExtensions = ["xls", "xlsx", "csv"];
  const fileExtension = selectFile.name.split(".").pop().toLowerCase();

  if (!validExtensions.includes(fileExtension)) {
    const msg = "Invalid file type";
    setShowMessage(msg);
    message.error(msg);
    return;
  }

  try {
    setLoading(true);

    const formData = new FormData();
    formData.append("import_file", selectFile);

    const response = await fetch(
      `${APIURL.baseURL.replace("/api", "")}/import_excel/importexcel.php`,
      {
        method: "POST",
        body: formData,
      }
    );

    // ✅ Properly parse JSON response
    const resData = await response.json();

    if (resData.status === "success") {
      const imported = resData.imported || 0;
      const skipped = resData.errors ? resData.errors.length : 0;

      setImportStats({ imported, skipped });

      if (imported > 0 && skipped === 0) {
        message.success(`${imported} row(s) imported successfully.`);
      } else if (imported > 0 && skipped > 0) {
        message.warning(
          `${imported} row(s) imported, ${skipped} skipped. Check details below.`
        );
      } else if (imported === 0 && skipped > 0) {
        message.warning(`${skipped} row(s) skipped. No new items imported.`);
      } else {
        message.info("No rows were imported.");
      }

      if (resData.errors && resData.errors.length > 0) {
        setErrors(resData.errors);
      }
    } else {
      const errMsg = resData.message || "Import failed.";
      setShowMessage(errMsg);
      message.error(errMsg);
    }
  } catch (error) {
    const errMsg = "Upload failed. Please try again.";
    setShowMessage(errMsg);
    message.error(errMsg);
    console.error("Upload Error:", error);
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">Excel Import</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <input
              type="file"
              name="import_file"
              accept=".xls,.csv,.xlsx"
              onChange={handleChange}
              className="form-control"
              disabled={loading}
            />

            <button
              type="submit"
              className="btn btn-primary mt-3"
              disabled={loading}
            >
              {loading ? "Importing" : "Import"}
            </button>
          </form>

          <br />

          {/* ✅ Show summary stats */}
          {(importStats.imported > 0 || importStats.skipped > 0) && (
            <div className="mt-3">
              <Alert
                type="info"
                message={
                  <>
                    <strong>Import Summary:</strong>
                    <div>
                      ✅ Rows Imported: <b>{importStats.imported}</b>
                    </div>
                    ⚠️ Rows Skipped: <b>{importStats.skipped}</b>
                  </>
                }
                showIcon
              />
            </div>
          )}

          {/* ❌ Show error message if any */}
          {showMessage && (
            <Alert
              message="Error"
              description={showMessage}
              type="error"
              showIcon
              className="mt-3"
            />
          )}

          {/* ⚠️ Show skipped rows in scrollable container */}
          {errors.length > 0 && (
            <div
              style={{
                maxHeight: "200px",
                overflowY: "auto",
                marginTop: "20px",
                border: "1px solid #f0f0f0",
                borderRadius: "8px",
                padding: "10px",
                background: "#fff7e6",
              }}
            >
              <Alert
                message="Some rows were skipped"
                description={
                  <ul style={{ marginBottom: 0, paddingLeft: "20px" }}>
                    {errors.map((err, idx) => (
                      <li key={idx} style={{ marginBottom: "4px" }}>
                        {err}
                      </li>
                    ))}
                  </ul>
                }
                type="warning"
                showIcon
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExcelImport;
